<template>
  <li class="duration-200">
    <div
      class="pl-4 py-2 flex space-x-2 items-center font-medium relative"
      :class="level && `!pl-[${(level + 1) * 1.5}em]`"
    >
      <div class="flex items-center h-5 cursor-pointer ske">
        <input v-model="selected" id="offers" aria-describedby="offers-description" name="offers" type="checkbox" class="focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded" @click="() => enable(!enabled)">
      </div>
      <span v-if="!to" class="ske">
        {{ name }}
      </span>
      <a v-else :href="to" target="_blank" class="hover:underline">
        {{ name }}
        <span v-if="products" class="text-gray-500 ml-1">({{ products }})</span>
      </a>

      <span v-if="filteredChildren && filteredChildren.length" class="absolute right-0 top-1/2 -translate-y-1/2" @click="showing = !showing">
        <span class="inline-block rounded-lg p-0.5 cursor-pointer hover:bg-gray-50 duration-200 border border-gray-200">
          <svg xmlns="http://www.w3.org/2000/svg" class="duration-200 h-5 w-5 text-gray-600" :class="showing && 'rotate-90'" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
          </svg>
        </span>
      </span>
    </div>

    <transition
      @enter="enter"
      @leave="leave"
    >
      <div v-if="showing && filteredChildren && filteredChildren.length" class="duration-200">
        <ul class="border-gray-100 border-t divide-y divide-gray-100" role="list">
          <category
            v-for="cat in filteredChildren"
            :key="cat.id"

            v-bind="{...$props, ...cat, level: (level || 0) + 1}"
          />
        </ul>
      </div>
    </transition>
  </li>
</template>

<script>

import TransitionFunctionConstructor from "@/mixins/transitionFunctionConstructor"

export default {
  mixins: [TransitionFunctionConstructor("enter", "leave", "height")],
  name: 'category',
  props: ['id', 'name', 'products', 'children', 'to', 'level', 'config', 'configuration', 'role', 'blockId', 'search'],
  data() {
    return {
      showing: false,
      selected: false,
    }
  },
  created() {
    this.selected = this.enabled
    for (const cat of this.children) {
      if (this.catIds.includes(cat.id)) {
        this.showing = true
        break;
      }
    }
  },
  methods: {
    removeId(ids, id) {
      const i = ids.indexOf(id)
      if (i > -1) ids.splice(i, 1)
    },
    removeAllChildren(ids, children) {
      children.forEach(child => {
        this.removeId(ids, child.id)
        child.children.length && this.removeAllChildren(ids, child.children)
      })
    },
    enable(enable) {
      const catIds = this.catIds

      if (enable) {
        if (!catIds.includes(this.id)) catIds.push(this.id)
        else return;
      } else {
        this.removeId(catIds, this.id)
        this.removeAllChildren(catIds, this.children)
      }

      console.warn("setBlockConfig: ", "enable")
      this.$store.dispatch('editor/setBlockConfig', {
        id: this.blockId,
        role: this.role,
        config: { [this.configuration.id]: catIds },
      })
    },
  },
  computed: {
    filteredChildren() {
      const search = this.search
      if (!search) return this.children

      return this.children.filter(cat => cat.name.toLowerCase().includes(search.toLowerCase()))
    },
    enabled() {
      return this.catIds.includes(this.id)
    },
    catIds() {
      return [...(this.config && this.config[this.configuration.id]) || []]
    },
  },
  watch: {
    enabled(enable) {
      this.selected = enable
    },
  },
}

</script>
